<template>
  <v-dialog v-model="dialog" max-width="500px" persistent>
    <v-card style="position: relative;">
      <v-card-title class="title pb-0">
        <span>Xuất file</span>
        <v-spacer></v-spacer>
        <v-btn icon ripple flat @click="close">
          <v-icon color="black">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text v-if="dataFileNames && dataFileNames.length" class="pt-0">
         <v-list>
          <v-list-tile
            v-for="(item, index) in dataFileNames"
            :key="index"
            avatar
          >
            <v-list-tile-avatar>
              <v-icon color="primary">description</v-icon>
            </v-list-tile-avatar>

            <v-list-tile-content>
              <v-list-tile-title v-text="item.name"></v-list-tile-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-btn icon ripple @click="exportFile(item)" v-if="!item.isDownload">
                <v-icon color="primary">get_app</v-icon>
              </v-btn>
              <v-icon color="green" v-else>done</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-card-text>
      <v-card-text v-else>
        Không có dữ liệu
      </v-card-text>
      <div class="d-flex loading-export" v-if="loading">
        <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    dialog: false,
    dataFileNames: [],
    totalFile: 0,
    fileName: ''
  }),

  methods: {
    open (totalFile, fileName) {
      this.totalFile = totalFile;
      this.fileName = fileName;
      this.createFileNameList();
      this.dialog = true;
    },

    close () {
      this.dialog = false;
    },

    exportFile (file) {
      this.dataFileNames[file.index - 1].isDownload = true;
      this.$emit('export', file);
    },

    // Tạo danh sách xuất file
    createFileNameList () {
      let now = moment().format('YYYY-MM-DD-HH-mm-ss');
      let fileName = `${this.fileName}_${now}`;
      this.dataFileNames = Array.from({ length: this.totalFile }, (v, i) => ({
        index: i + 1,
        name: `${fileName}${this.totalFile === 1 ? '' : '(' + (i + 1) + ')'}`,
        isDownload: false
      }));
    }
  }
};
</script>

<style scoped>
.loading-export{
 position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(255, 255, 255, 0.4);
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
}
.loading-export >>> .v-progress-circular{
  flex: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/DialogExportFile.vue